module.exports = __webpack_public_path__ + "static/media/insitu_gua_all_ope.8e884ca0.png";